
import Vue from 'vue'

export default Vue.extend({
  name: 'ConfirmationDialog',
  data: () => {
    return {
      modal: false,
      confirmation: false,
    }
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: false,
    },
    bodyHtml: {
      type: String,
      required: false,
    },
    confirmText: {
      type: String,
      required: false,
    },
    buttonCancel: {
      type: String,
      required: false,
    },
    buttonConfirm: {
      type: String,
      required: true,
    },
    buttonConfirmColor: {
      type: String,
      default: 'primary',
    },
    buttonAlternate: {
      type: String,
      required: false,
    },
  },
  watch: {
    value(val) {
      this.modal = val
    },
    modal(val) {
      !val && this.dialogCancel()
    },
  },
  methods: {
    dialogCancel() {
      this.confirmation = false
      this.$emit('input', false)
    },
    dialogConfirm() {
      this.$emit('confirm')
      this.$emit('input', false)
    },
    dialogAlternate() {
      this.$emit('alternate')
      this.$emit('input', false)
    },
  },
})
